export class Navigation {

    public static openInNewTab(url: string) {
        window.open(url, "_blank", "noreferrer,noopener");
    }

    public static pushState(url: string) {
        window.OK.navigation.go({url: url}, "pushState");
    }

    public static replaceState(url: string) {
        window.OK.navigation.accountState({url: url}, "replaceState");
    }

    public static back() {
        window.OK.navigation.back();
    }

    public static getMetaData() {
        return window.OK.navigation.getMetaData();
    }
}
